const map = {
  0: "bronze",
  1: "bronze",
  2: "silver",
  3: "gold",
  4: "gold",
  5: "prismatic",
  6: "prismatic",
};
for (const key in map) map[map[key]] = key;

const get = (value) => map[value];
export const styleToColor = (style) => get(style) ?? "bronze";
export const colorToStyle = (color) => get(color) ?? 0;
